import React, { useState } from 'react';
import axios from 'axios';
import './style/Addadhero.css'; // ✅ External CSS imported

export default function Addadhero() {
  const [adhero, setAdhero] = useState({
    productUrl: '',
    shopUrl: '',
    adhero: null,
  });
  const [fileName, setFileName] = useState(''); // for preview

  const api = 'https://mkbackend-production.up.railway.app';

  const handleImageSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      setAdhero((prevState) => ({
        ...prevState,
        adhero: file,
      }));
    }
  };

  const handleChange = (e) => {
    setAdhero({
      ...adhero,
      [e.target.name]: e.target.value,
    });
  };

  const addAdhero = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    try {
      const formData = new FormData();
      formData.append('adhero', adhero.adhero);
      formData.append('productUrl', adhero.productUrl);
      formData.append('shopUrl', adhero.shopUrl);

      const res = await axios.post(`${api}/adhero`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.success) {
        console.log('Ad added successfully');
      }
      alert('Added');
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <div className="add-adhero-container">
      <h2>Create New Ad</h2>
      <p className="subtitle">Fill in the details below</p>

      <form onSubmit={addAdhero} className="add-adhero-form">
        {/* File Upload */}
        <div className="form-group">
          <label>
            Ad Image <span className="required">*</span>
          </label>
          <div className="file-upload-wrapper">
            <div className="upload-icon">🖼️</div>
            <div className="upload-text">
              {fileName ? fileName : 'Click or drag to upload'}
            </div>
            <div className="upload-hint">PNG, JPG, WEBP (max 5MB)</div>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageSelect}
              required
            />
          </div>
          {fileName && (
            <div className="file-preview">
              <span className="file-name">{fileName}</span>
              <span className="file-size">
                {(adhero.adhero?.size / 1024).toFixed(1)} KB
              </span>
            </div>
          )}
        </div>

        {/* Product URL */}
        <div className="form-group">
          <label>
            Product URL <span className="required">*</span>
          </label>
          <input
            type="text"
            name="productUrl"
            placeholder="https://example.com/product"
            value={adhero.productUrl}
            onChange={handleChange}
            required
          />
        </div>

        {/* Shop URL */}
        <div className="form-group">
          <label>
            Shop URL <span className="required">*</span>
          </label>
          <input
            type="text"
            name="shopUrl"
            placeholder="https://example.com/shop"
            value={adhero.shopUrl}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" className="submit-btn">
          Create Ad
        </button>
      </form>
    </div>
  );
}